export default __webpack_public_path__ + "static/media/alphabetheader.24130b87.svg";